import { render, staticRenderFns } from "./tongBi.vue?vue&type=template&id=35f60b6d&scoped=true&"
import script from "./tongBi.vue?vue&type=script&lang=js&"
export * from "./tongBi.vue?vue&type=script&lang=js&"
import style0 from "./tongBi.vue?vue&type=style&index=0&id=35f60b6d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f60b6d",
  null
  
)

export default component.exports